// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editCase button[data-v-beeef02e] {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: none;\n  border: none;\n  font-size: 15px;\n  font-weight: 500;\n  color: #ffffff;\n  border: 1px solid #f24a55;\n  background: #f24a55;\n  border-radius: 4px;\n  padding: 0 10px;\n}\n.editCase button img[data-v-beeef02e] {\n  margin-right: 7px;\n  margin-bottom: -3px;\n  width: 15px;\n}", ""]);
// Exports
module.exports = exports;
